// extracted by mini-css-extract-plugin
export default {"Modal":"UpdateToOfferSentConfirmModal_Modal__5TKh-","Overlay":"UpdateToOfferSentConfirmModal_Overlay__eWO41"};